(() => {
  const FULL_PERCENT = 100;
  const DEFAULT_DISCOUNT_PERCENT = 10;
  const config = window.AnataiConfig || {};

  // あなタイの有効状態を返す。
  function isActive() {
    return config.active === true;
  }

  // 入力値と同じ単位であなタイ割引後の価格を返す。
  function getDiscountedPrice(value) {
    if (!isActive() || typeof value !== 'number' || !Number.isFinite(value)) {
      return null;
    }

    const configuredPercent = Number(config.discountPercent);
    const discountPercent = Number.isFinite(configuredPercent) ? configuredPercent : DEFAULT_DISCOUNT_PERCENT;
    return Math.round(value * (FULL_PERCENT - discountPercent) / FULL_PERCENT);
  }

  window.Anatai = {
    isActive,
    getDiscountedPrice,
  };
})();
